/**
 * @file The enable user selection action
 * @author HS
*/
import * as tslib_1 from "tslib";
import { ActionBase } from '../action';
var EnableUserSelectionAction = /** @class */ (function (_super) {
    tslib_1.__extends(EnableUserSelectionAction, _super);
    /**
     * Creates an instance of UserService
     * @param {UserService} userService
     * @param {string} icon
     * @param {string} labelKey
     */
    function EnableUserSelectionAction() {
        var _this = _super.call(this, 'sym-icon-enable', 'APP.MISC.USER.ENABLE') || this;
        /**
        * The success labelkey
        */
        _this.successLabelKey = 'APP.LISTS.ITEMS_SUCCESSFULLY_SAVED';
        return _this;
    }
    /**
     * Execute the action
     * @param {ActionConfiguration} actionConfiguration The action configuration
     */
    EnableUserSelectionAction.prototype.do = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        // Enable all selected users that are not enabled yet.
                        input.listBase.selected.forEach(function (item) {
                            if (item['Status'] !== 'ENABLED') {
                                item['enable']();
                            }
                        });
                        return [4 /*yield*/, this.save(input.breezeService)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Promise.resolve(this.successLabelKey)];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(error_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return EnableUserSelectionAction;
}(ActionBase));
export { EnableUserSelectionAction };
